import React from "react";
import type { ShopSectionEntity } from "../../../../../../domain/types/company-shop";
import { PREVIEW_COLORS, SECTION_COLUMN_CLASS } from "../../constants";

interface PreviewProductListProps {
  section: ShopSectionEntity;
}

export const PreviewProductList = ({ section }: PreviewProductListProps) => {
  const isCircle = section.cardShape === "CIRCLE";
  const columnClass =
    SECTION_COLUMN_CLASS[section.columnCount] ?? SECTION_COLUMN_CLASS[4];

  return (
    <div className="text-start flex flex-col flex-start py-[40px] px-[32px]">
      <h2
        className="mb-[0.5rem] text-[1.125rem] font-semibold"
        style={{ color: PREVIEW_COLORS.sectionTitle }}
      >
        {section.title || "상품 리스트"}
      </h2>
      {section.subtitle ? (
        <div
          className="mb-[1.5rem]"
          style={{ color: PREVIEW_COLORS.sectionSubtitle }}
        >
          {section.subtitle}
        </div>
      ) : (
        <div className="mb-[1rem]" />
      )}

      {section.products.length === 0 ? (
        <div
          className="py-[1.5rem] text-center"
          style={{ color: PREVIEW_COLORS.mutedText }}
        >
          선택된 상품이 없습니다.
        </div>
      ) : (
        <div className={`grid ${columnClass} gap-[16px] / items-start`}>
          {section.products.map((product) => (
            <div key={product.id} className="w-full">
              <div
                className={`drop-shadow-xl aspect-[1/1] mb-[0.75rem] ${
                  isCircle ? "rounded-full" : "rounded-[0.625rem]"
                }`}
                style={{ backgroundColor: PREVIEW_COLORS.thumbnailPlaceholder }}
              >
                <img
                  src={product.thumbnail ?? ""}
                  alt="썸네일 이미지."
                  className={`object-cover h-full w-full ${
                    isCircle ? "rounded-full" : "rounded-[0.625rem]"
                  }`}
                />
              </div>
              <div className={isCircle ? "text-center" : ""}>
                <h4
                  className="font-medium"
                  style={{ color: PREVIEW_COLORS.productList.productName }}
                >
                  {product.name}
                </h4>
                <span style={{ color: PREVIEW_COLORS.productList.productPrice }}>
                  {product.price}원
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
